import { APP_ROUTES, TestTaskType } from '../constants';
import { ILocationState } from './useUserRedirection';
import { matchPath, useLocation } from 'react-router-dom';
import { useIsMobileView } from './useIsMobileView';
import { useIsQuiz } from './useIsQuiz';
import { useUserTestTasks } from './useUserTestTasks';
import { useAppSelector } from 'src/redux';
import { userSelectors } from 'src/redux/user';

export const useShouldReserveChatMessageSpace = () => {
  const location: ILocationState = useLocation();
  const { currentTestTask } = useUserTestTasks();
  const isMobileView = useIsMobileView();
  const isQuiz = useIsQuiz();
  const userData = useAppSelector(userSelectors.getUserData);

  let shouldReserveChatMessageSpace =
    !(isQuiz && isMobileView) ||
    !(currentTestTask?.testTaskType === TestTaskType.INTERNAL && isMobileView);

  if (
    [`/${APP_ROUTES.APPLICATION_SUCCESS}`].includes(location.pathname) &&
    isMobileView
  ) {
    shouldReserveChatMessageSpace = false;
  }

  if (location.pathname.includes(`/${APP_ROUTES.CANCEL_APPLICATION}`)) {
    shouldReserveChatMessageSpace = false;
  }

  if (userData?.intermediateScreen) {
    shouldReserveChatMessageSpace = false;
  }

  if (
    isMobileView &&
    Boolean(matchPath(APP_ROUTES.VIDEO_INTERVIEW_SELECTION, location.pathname))
  ) {
    shouldReserveChatMessageSpace = false;
  }

  if (
    isMobileView &&
    Boolean(matchPath(APP_ROUTES.RECORD_VIDEO, location.pathname))
  ) {
    shouldReserveChatMessageSpace = false;
  }

  if (
    isMobileView &&
    Boolean(
      matchPath(APP_ROUTES.CANDIDATE_VIDEO_INTERVIEW_RECORD, location.pathname),
    )
  ) {
    shouldReserveChatMessageSpace = false;
  }

  if (
    isMobileView &&
    Boolean(
      matchPath(APP_ROUTES.CANDIDATE_VIDEO_INTERVIEW_START, location.pathname),
    )
  ) {
    shouldReserveChatMessageSpace = false;
  }

  if (
    Boolean(matchPath(APP_ROUTES.INTERVIEW_BOOKING_SCHEDULE, location.pathname))
  ) {
    shouldReserveChatMessageSpace = false;
  }

  if (
    Boolean(matchPath(APP_ROUTES.SKILLS_REQUIREMENTS, location.pathname)) ||
    Boolean(matchPath(APP_ROUTES.EDUCATION_REQUIREMENTS, location.pathname)) ||
    Boolean(matchPath(APP_ROUTES.VISA_REQUIREMENTS, location.pathname)) ||
    Boolean(
      matchPath(APP_ROUTES.WORKING_CONDITIONS_REQUIREMENTS, location.pathname),
    )
  ) {
    shouldReserveChatMessageSpace = false;
  }

  return shouldReserveChatMessageSpace;
};
